var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('v-progress-linear',{attrs:{"absolute":"","height":"2","background-color":"#D6D6D6","value":_vm.progress,"bottom":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }